import React from 'react';
const { useMemo } = React;
import { F } from '../../utils.jsx';
import QuoteList from './QuoteList.jsx';
import PayerPayments from './PayerPayments.jsx';
import { chainsOf } from '../../quoteChains.js';

// The company's quotes and contrataciones in its own tab: every company quote of this account, also the ones
// created from Contactos (Quote Recipient = company), each once. Each opens its single file in «Cotizaciones y
// cobros» (the same from every access). A personal quote is never company activity, even with this company
// linked as a reference.
export default function AccountQuotes({ account, intakes = [] }) {
  const chains = useMemo(() => chainsOf(intakes.filter(r => (r.fields?.['Account'] || []).includes(account?.id))).filter(c => c.kind === 'company'), [intakes, account?.id]);
  if (!account) return null;
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--globant-muted)', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 8 }}>Cotizaciones y contrataciones de la empresa</div>
      <div style={{ fontSize: 12, color: 'var(--globant-muted)', marginBottom: 8 }}>Todas las de {F(account, 'Account Name')}, también las creadas desde un contacto. Las cotizaciones personales de quienes trabajan aquí no son de la empresa y no aparecen.</div>
      {/* The company's own charges as payer: never the personal finances of the people who work there */}
      <PayerPayments payer={{ type: 'company', id: account.id }} name={F(account, 'Account Name')} intakes={intakes} />
      <QuoteList chains={chains} titleOf={(c) => (c.current || c.versions[c.versions.length - 1]).record.fields?.['Name'] || F(account, 'Account Name')} emptyText="Sin cotizaciones de la empresa." />
    </div>
  );
}
